import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reducer from "./panel/reducer";

export const store = createStore(reducer, applyMiddleware(thunk));
